export type EntityType = "task" | "bug" | "project" | "milestone"

const ENTITY_ID_KEYS: Record<EntityType, string[]> = {
  task: ["id", "task_id", "taskId", "task_uuid", "_id", "uuid"],
  bug: ["id", "bug_id", "bugId", "bug_uuid", "_id", "uuid"],
  project: ["id", "project_id", "projectId", "project_uuid", "_id", "uuid"],
  milestone: ["id", "milestone_id", "milestoneId", "milestone_uuid", "_id", "uuid"],
}

const UUID_V4_OR_V1_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export function isLikelyEntityId(value: unknown): value is string {
  if (typeof value !== "string") return false
  const normalized = value.trim()
  if (!normalized) return false
  return UUID_V4_OR_V1_PATTERN.test(normalized)
}

export function resolveEntityId(entity: unknown, type: EntityType): string {
  if (!entity) return ""

  if (typeof entity === "string" || typeof entity === "number") {
    return String(entity).trim()
  }

  if (typeof entity !== "object") return ""

  const source = entity as Record<string, unknown>

  for (const key of ENTITY_ID_KEYS[type]) {
    const value = source[key]
    if (value !== null && value !== undefined) {
      const normalized = String(value).trim()
      if (normalized) return normalized
    }
  }

  // Fallback for nested payloads like { task: { id: ... } }
  const nestedValue = source[type]
  if (nestedValue && typeof nestedValue === "object") {
    return resolveEntityId(nestedValue, type)
  }

  return ""
}

export function buildEntityDetailHref(entity: unknown, type: EntityType): string | null {
  const id = resolveEntityId(entity, type)
  if (!isLikelyEntityId(id)) return null

  if (type === "task") return `/tasks/detail?id=${encodeURIComponent(id)}`
  if (type === "bug") return `/bugs/detail?id=${encodeURIComponent(id)}`
  if (type === "project") return `/projects/detail?id=${encodeURIComponent(id)}`
  return `/milestones/detail?id=${encodeURIComponent(id)}`
}
